export function oeLogo () {
  return `${ENVIRONMENT.publicDirURL()}/images/OE_black.png`
}

export function mwLogo () {
  return `${ENVIRONMENT.publicDirURL()}/images/MW_LR_Landscape_small_27px height.png`
}
